import React, { HTMLAttributes } from 'react';

import DevText from '@app/components/Text';
import { Callout, Intent } from '@blueprintjs/core';

import { ClosedParentNotice as Notice } from '../../utils';

export interface ClosedParentNoticeProps {
    notice: Notice | null;
}

export type Props = HTMLAttributes<HTMLDivElement> & ClosedParentNoticeProps;

// Amber rather than red: nothing is broken. A paused, delivered or archived Request simply has
// no new work to take, and the write controls are hidden rather than disabled to match the
// established isTaskDelivered idiom elsewhere in the product.
//
// Hiding them alone leaves the page looking emptier than the designer expects, with no way to
// tell "this Request is closed" from "these buttons are missing". The one control that DOES
// survive — banking work already done — is named explicitly, so a designer mid-session is not
// left guessing whether their running timer can still be saved.
const ClosedParentNotice: React.FC<Props> = ({ notice, ...props }) => {
    if (!notice) {
        return null;
    }

    return (
        <div {...props}>
            <Callout intent={Intent.WARNING} title={notice.title}>
                <DevText>{notice.message}</DevText>
            </Callout>
        </div>
    );
};

export default ClosedParentNotice;
